/* eslint-disable no-unused-vars */
import React, { useState } from "react"
import useStyles from "./useStyles"
import { Box, CircularProgress, Modal, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 225,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}
function ModalConfirmChange({ title, onClose, onConfirm, message, handleChange }) {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)

  const handleChangeUserAdmin = async () => {
    setShowCircularProgress(true)
    await onConfirm()
    setShowCircularProgress(false)
    onClose()
  }

  return (
    <>
      <Modal open onClose={onClose}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                fontSize: "medium",
                color: "#263057",
                cursor: "pointer",
              }}
              onClick={onClose}
            />
          </div>
          <div>
            <Typography sx={{ color: "#263057", fontSize: "1.3em" }}>
              {title}
            </Typography>
          </div>
          <Typography
            sx={{
              color: "#263057",
              fontFamily: "Roboto",
              marginTop: "5%",
            }}
          >
            {message}
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: "45%" }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              onConfirm={handleChangeUserAdmin}
            />
            <ButtonClose onClose={onClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({ showCircularProgress, onConfirm }) {
  const classes = useStyles()

  return (
    <button className={classes.confirmButton}>
      {showCircularProgress ? (
        <CircularProgress size="1.5rem" sx={{ color: "#fff"}} />
      ) : (
        <Typography
          className={classes.confirmButtonTypography}
          variant="contained"
          onClick={onConfirm}
        >
          Confirmar
        </Typography>
      )}
    </button>
  )
}

function ButtonClose({ onClose }) {
  const classes = useStyles()

  return (
    <Box onClick={onClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}

export default ModalConfirmChange
